// App.js - C.L.Seifert Bootstrap Project
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { NotificationProvider } from '@ajat/design-system/Notification/useNotification';
import PageLoaderHost from '@ajat/design-system/PageLoader';

// Pages
import ProjectsPage from './components/Pages/ProjectsPage';
import NotFoundPage from './components/Pages/NotFoundPage';
import { deployment } from './config/deployment';
import { isDevHost } from './config/devHost';

import DesignSystemPage from './components/Pages/DesignSystem';
import CLSDKLanding from './components/Clothing/CLS-DK/Landing';
import CLSDKProductDetails from './components/Clothing/CLS-DK/Product';
import { ProductPackage as CLSDKProductPackage } from './components/Clothing/CLS-DK/Product';
import CLSDKSchoolShop from './components/Clothing/CLS-DK/SchoolShop';
import CLSDKBulkProduct from './components/Clothing/CLS-DK/BulkProduct';
import CLSDKShoppingCart from './components/Clothing/CLS-DK/ShoppingCart';
import ABCSELanding from './components/Clothing/ABC-SE/Landing';
import ABCSEProductDetails from './components/Clothing/ABC-SE/Product';
import { ProductPackage as ABCSEProductPackage } from './components/Clothing/ABC-SE/Product';
import ABCSESchoolShop from './components/Clothing/ABC-SE/SchoolShop';
import ABCSEAccessories from './components/Clothing/ABC-SE/Accessories';
import ABCSEBulkProduct from './components/Clothing/ABC-SE/BulkProduct';
import ABCSEShoppingCart from './components/Clothing/ABC-SE/ShoppingCart';
import ABCSECheckout from './components/Clothing/ABC-SE/Checkout';
import { ThankYou as ABCSEThankYou } from './components/Clothing/ABC-SE/Checkout';
import ABCSEEditOrder from './components/Clothing/ABC-SE/EditOrder';
// Student Club routing hidden for now — see routes below.
// import ABCSEStudentClub, { ClubShop as ABCSEClubShop } from './components/Clothing/ABC-SE/StudentClub';
import CLSDKCheckout from './components/Clothing/CLS-DK/Checkout';
import { ThankYou as CLSDKThankYou } from './components/Clothing/CLS-DK/Checkout';
import CLSDKEditOrder from './components/Clothing/CLS-DK/EditOrder';
import CLSDKStudentClub, { ClubShop as CLSDKClubShop } from './components/Clothing/CLS-DK/StudentClub';
import CLSDKCreateSchool from './components/Clothing/CLS-DK/CreateSchool';
import CLSDKLogoGenerator from './components/Clothing/CLS-DK/LogoGenerator';
import CLSDKIdeas from './components/Clothing/CLS-DK/Ideas';
import CLSSELanding from './components/Clothing/CLS-SE/Landing';
import CLSSEProductDetails from './components/Clothing/CLS-SE/Product';
import { ProductPackage as CLSSEProductPackage } from './components/Clothing/CLS-SE/Product';
import CLSSESchoolShop from './components/Clothing/CLS-SE/SchoolShop';
import CLSSEAccessories from './components/Clothing/CLS-SE/Accessories';
import CLSSEBulkProduct from './components/Clothing/CLS-SE/BulkProduct';
import CLSSEShoppingCart from './components/Clothing/CLS-SE/ShoppingCart';
import CLSSECheckout from './components/Clothing/CLS-SE/Checkout';
import { ThankYou as CLSSEThankYou } from './components/Clothing/CLS-SE/Checkout';
import CLSSEEditOrder from './components/Clothing/CLS-SE/EditOrder';
// Student Club routing hidden for now — see routes below.
// import CLSSEStudentClub, { ClubShop as CLSSEClubShop } from './components/Clothing/CLS-SE/StudentClub';
import CLSFILanding from './components/Clothing/CLS-FI/Landing';
import CLSFIProductDetails from './components/Clothing/CLS-FI/Product';
import { ProductPackage as CLSFIProductPackage } from './components/Clothing/CLS-FI/Product';
import CLSFISchoolShop from './components/Clothing/CLS-FI/SchoolShop';
import CLSFIAccessories from './components/Clothing/CLS-FI/Accessories';
import CLSFIBulkProduct from './components/Clothing/CLS-FI/BulkProduct';
import CLSFIShoppingCart from './components/Clothing/CLS-FI/ShoppingCart';
import CLSFICheckout from './components/Clothing/CLS-FI/Checkout';
import { ThankYou as CLSFIThankYou } from './components/Clothing/CLS-FI/Checkout';
import CLSFIEditOrder from './components/Clothing/CLS-FI/EditOrder';
import CLSFIStudentClub, { ClubShop as CLSFIClubShop } from './components/Clothing/CLS-FI/StudentClub';
import CLSDKMenuItemShop from './components/Clothing/CLS-DK/MenuItemShop/MenuItemShop';
import CLSSEMenuItemShop from './components/Clothing/CLS-SE/MenuItemShop/MenuItemShop';
import ABCSEMenuItemShop from './components/Clothing/ABC-SE/MenuItemShop/MenuItemShop';
import CLSFIMenuItemShop from './components/Clothing/CLS-FI/MenuItemShop/MenuItemShop';
import CLSFICollectionShop from './components/Clothing/CLS-FI/CollectionShop/CollectionShop';
import CLSDKCollectionShop from './components/Clothing/CLS-DK/CollectionShop/CollectionShop';
import CLSSECollectionShop from './components/Clothing/CLS-SE/CollectionShop/CollectionShop';
import ABCSECollectionShop from './components/Clothing/ABC-SE/CollectionShop/CollectionShop';
import { FAQ as CLSDKFAQ, Contact as CLSDKContact, SizeGuide as CLSDKSizeGuide, TrykBroderi as CLSDKTrykBroderi, TermsConditions as CLSDKTermsConditions, PrivacyPolicy as CLSDKPrivacyPolicy } from './components/Clothing/CLS-DK/HelpCenter';
import { FAQ as CLSSEFAQ, Contact as CLSSEContact, SizeGuide as CLSSESizeGuide, TermsConditions as CLSSETermsConditions, PrivacyPolicy as CLSSEPrivacyPolicy } from './components/Clothing/CLS-SE/HelpCenter';
import { FAQ as CLSFIFAQ, Contact as CLSFIContact, SizeGuide as CLSFISizeGuide, TermsConditions as CLSFITermsConditions, PrivacyPolicy as CLSFIPrivacyPolicy } from './components/Clothing/CLS-FI/HelpCenter';
import { FAQ as ABCSEFAQ, Contact as ABCSEContact, SizeGuide as ABCSESizeGuide, TermsConditions as ABCSETermsConditions, PrivacyPolicy as ABCSEPrivacyPolicy } from './components/Clothing/ABC-SE/HelpCenter';
import ScrollToTop from './components/Clothing/Common/ScrollToTop';
import CookieConsent from './components/Clothing/Common/CookieConsent';
import { BrandErrorBoundary } from './components/Clothing/Common/ErrorPages';
import { NotFound as CLSDKNotFound, ServerError as CLSDKServerError } from './components/Clothing/CLS-DK/ErrorPages';
import { NotFound as CLSSENotFound, ServerError as CLSSEServerError } from './components/Clothing/CLS-SE/ErrorPages';
import { NotFound as CLSFINotFound, ServerError as CLSFIServerError } from './components/Clothing/CLS-FI/ErrorPages';
import { NotFound as ABCSENotFound, ServerError as ABCSEServerError } from './components/Clothing/ABC-SE/ErrorPages';

// Styles
import './App.css';

/*
 * The ProjectsPage (internal project picker) is a DEV tool — it must never be
 * shown to customers. On the public brand domains an unknown path redirects to
 * the brand's landing; on any other production host (e.g. the legacy
 * clothing-new host) it falls back to a neutral 404.
 * The local dev server counts as a dev host on ANY hostname, so the LAN address
 * (http://<mac-LAN-IP>:3001, phone testing) gets the dev pages too; a
 * production build is never in development mode.
 */
const rootElement = isDevHost
  ? <ProjectsPage />
  : (deployment ? <Navigate to={deployment.internalBase} replace /> : <NotFoundPage />);

/*
 * Create Shop ("Shop builder") — internal sales-rep wizard (shows kickback
 * pricing), shared by ABC-SE / CLS-SE / CLS-DK (Clothing/Common/CreateShop).
 * Dev-only like ProjectsPage and lazy so each ships as its own chunk; on any
 * other host the path renders that brand's 404.
 */
const devOnlyLazy = (LazyPage, notFound) => (isDevHost
  ? <React.Suspense fallback={null}><LazyPage /></React.Suspense>
  : notFound);
const ABCSECreateShop = React.lazy(() => import('./components/Clothing/ABC-SE/CreateShop'));
const CLSSECreateShop = React.lazy(() => import('./components/Clothing/CLS-SE/CreateShop'));
const CLSDKCreateShop = React.lazy(() => import('./components/Clothing/CLS-DK/CreateShop'));

// Safari viewport height fix
function setSafeViewportHeight() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

if (typeof window !== 'undefined') {
  setSafeViewportHeight();
  window.addEventListener('resize', setSafeViewportHeight);
  window.addEventListener('orientationchange', () => {
    setTimeout(setSafeViewportHeight, 100);
  });
}

// Main App Component
function App() {
  return (
    <CartProvider>
    <ScrollToTop />
    <CookieConsent />
    <BrandErrorBoundary
      fallbacks={{
        'cls-dk': CLSDKServerError,
        'cls-se': CLSSEServerError,
        'cls-fi': CLSFIServerError,
        'abc-se': ABCSEServerError,
      }}
    >
    <Routes>
      <Route path="/" element={rootElement} />
      <Route path="/landing" element={rootElement} />
      <Route path="/clothing/cls-dk" element={<CLSDKLanding />} />
      <Route path="/clothing/cls-dk/product-details/:slug" element={<CLSDKProductDetails />} />
      <Route path="/clothing/cls-dk/school-shop" element={<CLSDKSchoolShop />} />
      <Route path="/clothing/cls-dk/school-shop/:schoolSlug" element={<CLSDKSchoolShop />} />
      <Route path="/clothing/cls-dk/school-shop/:schoolSlug/product/:variationId" element={<CLSDKProductDetails />} />
      <Route path="/clothing/cls-dk/school-shop/:schoolSlug/product-package/:slug" element={<CLSDKProductPackage />} />
      <Route path="/clothing/cls-dk/school-shop/:schoolSlug/:shopSlug" element={<CLSDKSchoolShop />} />
      <Route path="/clothing/cls-dk/school-shop/:schoolSlug/:shopSlug/:groupSlug" element={<CLSDKSchoolShop />} />
      <Route path="/clothing/cls-dk/shop/:menuSlug" element={<CLSDKMenuItemShop />} />
      <Route path="/clothing/cls-dk/collection/:collectionSlug" element={<CLSDKCollectionShop />} />
      <Route path="/clothing/cls-dk/bulk-product/:slug" element={<CLSDKBulkProduct />} />
      <Route path="/clothing/cls-dk/shopping-cart" element={<CLSDKShoppingCart />} />
      <Route path="/clothing/cls-dk/product-package/:slug" element={<CLSDKProductPackage />} />
      <Route path="/clothing/cls-dk/checkout" element={<CLSDKCheckout />} />
      <Route path="/clothing/cls-dk/thank-you" element={<CLSDKThankYou />} />
      <Route path="/clothing/cls-dk/edit-order" element={<CLSDKEditOrder />} />
      <Route path="/clothing/cls-dk/edit-order/:orderNumber" element={<CLSDKEditOrder />} />
      <Route path="/clothing/cls-dk/student-club" element={<CLSDKStudentClub />} />
      <Route path="/clothing/cls-dk/student-club/:clubSlug" element={<CLSDKClubShop />} />
      <Route path="/clothing/cls-dk/create-school" element={<CLSDKCreateSchool />} />
      <Route path="/clothing/cls-dk/create-shop" element={devOnlyLazy(CLSDKCreateShop, <CLSDKNotFound />)} />
      <Route path="/clothing/cls-dk/logo-generator" element={<CLSDKLogoGenerator />} />
      <Route path="/clothing/cls-dk/ideas" element={<CLSDKIdeas />} />
      <Route path="/clothing/cls-dk/faq" element={<CLSDKFAQ />} />
      <Route path="/clothing/cls-dk/contact" element={<CLSDKContact />} />
      <Route path="/clothing/cls-dk/size-guide" element={<CLSDKSizeGuide />} />
      <Route path="/clothing/cls-dk/tryk-broderi" element={<CLSDKTrykBroderi />} />
      <Route path="/clothing/cls-dk/terms" element={<CLSDKTermsConditions />} />
      <Route path="/clothing/cls-dk/privacy" element={<CLSDKPrivacyPolicy />} />
      <Route path="/clothing/abc-se" element={<ABCSELanding />} />
      <Route path="/clothing/abc-se/product-details/:slug" element={<ABCSEProductDetails />} />
      <Route path="/clothing/abc-se/product-package/:slug" element={<ABCSEProductPackage />} />
      <Route path="/clothing/abc-se/school-shop" element={<ABCSESchoolShop />} />
      <Route path="/clothing/abc-se/school-shop/:schoolSlug" element={<ABCSESchoolShop />} />
      <Route path="/clothing/abc-se/school-shop/:schoolSlug/product/:variationId" element={<ABCSEProductDetails />} />
      <Route path="/clothing/abc-se/school-shop/:schoolSlug/product-package/:slug" element={<ABCSEProductPackage />} />
      <Route path="/clothing/abc-se/school-shop/:schoolSlug/:shopSlug" element={<ABCSESchoolShop />} />
      <Route path="/clothing/abc-se/school-shop/:schoolSlug/:shopSlug/:groupSlug" element={<ABCSESchoolShop />} />
      <Route path="/clothing/abc-se/shop/:menuSlug" element={<ABCSEMenuItemShop />} />
      <Route path="/clothing/abc-se/collection/:collectionSlug" element={<ABCSECollectionShop />} />
      <Route path="/clothing/abc-se/accessories" element={<ABCSEAccessories />} />
      <Route path="/clothing/abc-se/bulk-product/:slug" element={<ABCSEBulkProduct />} />
      <Route path="/clothing/abc-se/shopping-cart" element={<ABCSEShoppingCart />} />
      <Route path="/clothing/abc-se/checkout" element={<ABCSECheckout />} />
      <Route path="/clothing/abc-se/thank-you" element={<ABCSEThankYou />} />
      <Route path="/clothing/abc-se/edit-order" element={<ABCSEEditOrder />} />
      <Route path="/clothing/abc-se/edit-order/:orderNumber" element={<ABCSEEditOrder />} />
      {/* Student Club routing hidden for now.
      <Route path="/clothing/abc-se/student-club" element={<ABCSEStudentClub />} />
      <Route path="/clothing/abc-se/student-club/:clubSlug" element={<ABCSEClubShop />} />
      */}
      <Route path="/clothing/abc-se/faq" element={<ABCSEFAQ />} />
      <Route path="/clothing/abc-se/contact" element={<ABCSEContact />} />
      <Route path="/clothing/abc-se/size-guide" element={<ABCSESizeGuide />} />
      <Route path="/clothing/abc-se/terms" element={<ABCSETermsConditions />} />
      <Route path="/clothing/abc-se/privacy" element={<ABCSEPrivacyPolicy />} />
      <Route path="/clothing/abc-se/create-shop" element={devOnlyLazy(ABCSECreateShop, <ABCSENotFound />)} />
      <Route path="/clothing/cls-se" element={<CLSSELanding />} />
      <Route path="/clothing/cls-se/product-details/:slug" element={<CLSSEProductDetails />} />
      <Route path="/clothing/cls-se/product-package/:slug" element={<CLSSEProductPackage />} />
      <Route path="/clothing/cls-se/school-shop" element={<CLSSESchoolShop />} />
      <Route path="/clothing/cls-se/school-shop/:schoolSlug" element={<CLSSESchoolShop />} />
      <Route path="/clothing/cls-se/school-shop/:schoolSlug/product/:variationId" element={<CLSSEProductDetails />} />
      <Route path="/clothing/cls-se/school-shop/:schoolSlug/product-package/:slug" element={<CLSSEProductPackage />} />
      <Route path="/clothing/cls-se/school-shop/:schoolSlug/:shopSlug" element={<CLSSESchoolShop />} />
      <Route path="/clothing/cls-se/school-shop/:schoolSlug/:shopSlug/:groupSlug" element={<CLSSESchoolShop />} />
      <Route path="/clothing/cls-se/shop/:menuSlug" element={<CLSSEMenuItemShop />} />
      <Route path="/clothing/cls-se/collection/:collectionSlug" element={<CLSSECollectionShop />} />
      <Route path="/clothing/cls-se/accessories" element={<CLSSEAccessories />} />
      <Route path="/clothing/cls-se/bulk-product/:slug" element={<CLSSEBulkProduct />} />
      <Route path="/clothing/cls-se/shopping-cart" element={<CLSSEShoppingCart />} />
      <Route path="/clothing/cls-se/checkout" element={<CLSSECheckout />} />
      <Route path="/clothing/cls-se/thank-you" element={<CLSSEThankYou />} />
      <Route path="/clothing/cls-se/edit-order" element={<CLSSEEditOrder />} />
      <Route path="/clothing/cls-se/edit-order/:orderNumber" element={<CLSSEEditOrder />} />
      {/* Student Club routing hidden for now.
      <Route path="/clothing/cls-se/student-club" element={<CLSSEStudentClub />} />
      <Route path="/clothing/cls-se/student-club/:clubSlug" element={<CLSSEClubShop />} />
      */}
      <Route path="/clothing/cls-se/faq" element={<CLSSEFAQ />} />
      <Route path="/clothing/cls-se/contact" element={<CLSSEContact />} />
      <Route path="/clothing/cls-se/size-guide" element={<CLSSESizeGuide />} />
      <Route path="/clothing/cls-se/terms" element={<CLSSETermsConditions />} />
      <Route path="/clothing/cls-se/privacy" element={<CLSSEPrivacyPolicy />} />
      <Route path="/clothing/cls-fi" element={<CLSFILanding />} />
      <Route path="/clothing/cls-fi/product-details/:slug" element={<CLSFIProductDetails />} />
      <Route path="/clothing/cls-fi/school-shop" element={<CLSFISchoolShop />} />
      <Route path="/clothing/cls-fi/school-shop/:schoolSlug" element={<CLSFISchoolShop />} />
      <Route path="/clothing/cls-fi/school-shop/:schoolSlug/product/:variationId" element={<CLSFIProductDetails />} />
      <Route path="/clothing/cls-fi/school-shop/:schoolSlug/product-package/:slug" element={<CLSFIProductPackage />} />
      <Route path="/clothing/cls-fi/school-shop/:schoolSlug/:shopSlug" element={<CLSFISchoolShop />} />
      <Route path="/clothing/cls-fi/school-shop/:schoolSlug/:shopSlug/:groupSlug" element={<CLSFISchoolShop />} />
      <Route path="/clothing/cls-fi/shop/:menuSlug" element={<CLSFIMenuItemShop />} />
      <Route path="/clothing/cls-fi/collection/:collectionSlug" element={<CLSFICollectionShop />} />
      <Route path="/clothing/cls-fi/accessories" element={<CLSFIAccessories />} />
      <Route path="/clothing/cls-fi/bulk-product/:slug" element={<CLSFIBulkProduct />} />
      <Route path="/clothing/cls-fi/shopping-cart" element={<CLSFIShoppingCart />} />
      <Route path="/clothing/cls-fi/product-package/:slug" element={<CLSFIProductPackage />} />
      <Route path="/clothing/cls-fi/checkout" element={<CLSFICheckout />} />
      <Route path="/clothing/cls-fi/thank-you" element={<CLSFIThankYou />} />
      <Route path="/clothing/cls-fi/edit-order" element={<CLSFIEditOrder />} />
      <Route path="/clothing/cls-fi/edit-order/:orderNumber" element={<CLSFIEditOrder />} />
      <Route path="/clothing/cls-fi/student-club" element={<CLSFIStudentClub />} />
      <Route path="/clothing/cls-fi/student-club/:clubSlug" element={<CLSFIClubShop />} />
      <Route path="/clothing/cls-fi/faq" element={<CLSFIFAQ />} />
      <Route path="/clothing/cls-fi/contact" element={<CLSFIContact />} />
      <Route path="/clothing/cls-fi/size-guide" element={<CLSFISizeGuide />} />
      <Route path="/clothing/cls-fi/terms" element={<CLSFITermsConditions />} />
      <Route path="/clothing/cls-fi/privacy" element={<CLSFIPrivacyPolicy />} />
      <Route path="/design-system/*" element={<DesignSystemPage />} />
      <Route path="/clothing/cls-dk/error" element={<CLSDKServerError />} />
      <Route path="/clothing/cls-dk/*" element={<CLSDKNotFound />} />
      <Route path="/clothing/cls-se/error" element={<CLSSEServerError />} />
      <Route path="/clothing/cls-se/create-shop" element={devOnlyLazy(CLSSECreateShop, <CLSSENotFound />)} />
      <Route path="/clothing/cls-se/*" element={<CLSSENotFound />} />
      <Route path="/clothing/cls-fi/error" element={<CLSFIServerError />} />
      <Route path="/clothing/cls-fi/*" element={<CLSFINotFound />} />
      <Route path="/clothing/abc-se/error" element={<ABCSEServerError />} />
      <Route path="/clothing/abc-se/*" element={<ABCSENotFound />} />
      <Route path="*" element={rootElement} />
    </Routes>
    </BrandErrorBoundary>
    {/* After the routes: pages register in layout effects that run first. */}
    <PageLoaderHost />
    <NotificationProvider />
    </CartProvider>
  );
}

export default App;
